import { Box, Typography, useTheme } from "@mui/material";
import { theme } from "../../theme";

interface BoxEle {
    title: String,
    subtitle: String,
    icon: any,
    children: React.ReactNode
    increase: String
}

const StatBox: React.FC<BoxEle> = (props) => {

    return (
        <Box width="100%" m="0" sx={{ minWidth: 0 }}>
            <Box display="flex" justifyContent="space-between">
                <Box sx={{ minWidth: 0 }}>
                    {props.icon}
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        noWrap
                        sx={{ color: "text.primary", fontSize: { xs: "1.1rem", sm: "1.5rem" } }}
                    >
                        {props.title}
                    </Typography>
                </Box>
                <Box>
                    {props.children}
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt="2px" sx={{ minWidth: 0 }}>
                <Typography
                    noWrap
                    title={String(props.subtitle)}
                    sx={{
                        color: theme.palette.text.secondary,
                        fontSize: { xs: "0.75rem", sm: "0.9rem" },
                        minWidth: 0,
                    }}
                >
                    {props.subtitle}
                </Typography>
                <Typography
                    noWrap
                    sx={{ color: theme.palette.text.secondary, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}
                >
                    {props.increase}
                </Typography>
            </Box>
        </Box>
    );
};

export default StatBox;